import { render, staticRenderFns } from "./DispatchAdd.vue?vue&type=template&id=7ff7a70a&"
import script from "./DispatchAdd.vue?vue&type=script&lang=tsx&"
export * from "./DispatchAdd.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports